import { createFileRoute } from "@tanstack/react-router";
import BcbsnmInsurance, { config } from "@/pages/BcbsnmInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbsnm-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS NM TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield New Mexico coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "BCBS NM TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield New Mexico coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbsnm-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbsnm-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsnmInsurance />;
}
